export const BASE_URL = "https://prbackend.codeartisan.asia/api";